module.exports = __webpack_public_path__ + "img/diamonds5_2.89a0ad80.png";